
import { Message } from '@/lib/session';

export const handleTestCommand = (command: string): Message | null => {
  if (command === 'product-card') {
    return {
      role: 'assistant',
      content: 'Here\'s an example of a product card with all features enabled:',
      components: [{
        type: 'product-card',
        props: {
          product: {
            id: 'rx350-123',
            name: '2017 Lexus RX 350 F Sport',
            description: 'Luxury SUV with advanced safety features and premium amenities including blind spot monitoring, adaptive cruise control, and premium leather interior. Well-maintained with complete service history.',
            imageUrl: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158',
            price: '$27,995',
            link: 'https://example.com/vehicle',
            specifications: {
              year: '2017',
              make: 'Lexus',
              model: 'RX 350',
              trim: 'F Sport',
              mileage: 69755
            },
            competitiveListings: [
              {
                dealerName: 'DARCARS Lexus Of Silver Spring',
                mileage: 72365,
                price: 28995,
                link: 'https://example.com/listing1',
                reviews: {
                  rating: 3.9,
                  totalReviews: 95
                }
              },
              {
                dealerName: 'Lexus of Towson',
                mileage: 69755,
                price: 26436,
                link: 'https://example.com/listing2',
                reviews: {
                  rating: 4.8,
                  totalReviews: 128
                }
              }
            ]
          }
        }
      }]
    };
  }
  return null;
};
